import React, { useState } from "react";
// import * as Styled from './styles';
import {
  GOFloatingbox,
  GOInput,
  GOButton,
  GODropbox,
  GOPostCode,
  GOError,
  SmallTitle
} from "../../../components";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  NetEmployeeAdd,
  NetEmployeeDelete,
  NetEmployeeEdit
} from "../../../actions";
import { actionResetEmployeePassword } from "../../../stores/actions";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  UFloatingContainer,
  UFloatingBoxHeader,
  UFloatingBoxFooter,
  UFloatingBoxBody
} from "../../../GlobalUtilityStyles";

interface AddProps {
  update?: any;
  onClickExit?: () => void;
  data?: any;
  detailData?: any;
}
interface addDataType {
  phoneNumber: string;
  password: string;
  address: any;
}

interface ParamsType {
  id?: string;
}

const Add = (props: AddProps) => {
  // 레슨프로인터벌 추가
  const lessonInterval = props.detailData?.lessonInterval;

  const defaultAddData = {
    phoneNumber: "",
    password: "",
    address: null
  };
  const [addData, setAddData] = useState<addDataType>(
    props.data
      ? {
          ...props.data
        }
      : defaultAddData
  );
  const { register, handleSubmit, errors } = useForm({
    defaultValues: props.data && {
      ...props.data,
      ...props.detailData,
      dateOfBirth: props.data.dateOfBirth?.split("T")[0]
    }
  });
  const { t } = useTranslation();

  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams<ParamsType>();

  const [post, viewPost] = useState(false);

  const handleChange = (e: any) => {
    if (e.target.name === "phoneNumber") {
      setAddData({
        ...addData,
        password: e.target.value.substring(
          e.target.value.length - 4,
          e.target.value.length
        ),
        phoneNumber: e.target.value
      });
    } else {
      setAddData({
        ...addData,
        [e.target.name]: e.target.value
      });
    }
  };

  const handleAddressChange = (e: any) => {
    setAddData({
      ...addData,
      address: e
    });
  };

  const onDeleteEmployee = (t: any) => {
    let result = window.confirm(t("components.employee.confirmDelete"));
    if (result) {
      NetEmployeeDelete(props.data.id)
        .then((res: any) => {
          alert(t("components.employee.confirmDeleteSuccess"));
          if (props.onClickExit) {
            props.onClickExit();
          }
          history.push("/admin/employee/list");
        })
        .catch((err: any) => console.log(err));
    }
  };

  const onResetPassword = (t: any) => {
    if (window.confirm(t("components.employee.confirmResetPassword"))) {
      dispatch(
        actionResetEmployeePassword(params.id, () => {
          alert(t("components.employee.alertMessagePasswordReset"));
        })
      );
    }
  };

  const onSubmit = (data: any) => {
    if (props.data) {
      // 수정시
      NetEmployeeEdit({ ...addData, ...data }, props.data.id).then(res => {
        alert(t("user.editOK"));
        if (props.onClickExit) {
          props.onClickExit();
        }
        if (props.update) {
          props.update();
        }
      });
    } else {
      // 등록시
      if (addData.password) {
        NetEmployeeAdd({ ...addData, ...data }).then(res => {
          alert(t("components.employee.employeeRegistered"));
          setAddData(defaultAddData);
          if (props.onClickExit) {
            props.onClickExit();
          }
        });
      } else {
        alert(t("components.employee.checkPassword"));
      }
    }
  };

  // @ts-ignore
  // @ts-ignore
  // @ts-ignore
  return (
    <GOFloatingbox width={750}>
      {props.data ? (
        <UFloatingContainer as="form" onSubmit={handleSubmit(onSubmit)}>
          <UFloatingBoxHeader>
            <h1>{props.data ? t("employee.edit") : t("employee.add")}</h1>
            <p>{props.data ? t("employee.editInfo") : t("employee.addInfo")}</p>
          </UFloatingBoxHeader>
          <UFloatingBoxBody flex>
            <div className="flex_box">
              <SmallTitle body={t("user.baseInfo")} />
              <GOInput
                label={t("employee.name")}
                name="name"
                rref={register({ maxLength: 30 })}
                error={errors.name}
                required
              />
              {errors.name && (
                <GOError body={`${t("sign.nameErrorMaxLength")}`} />
              )}
              <GODropbox
                label={t("user.sex")}
                name="sex"
                rref={register}
                required
                data={[
                  { value: 0, body: t("common.male") },
                  { value: 1, body: t("common.female") }
                ]}
              />
              <GOInput
                name="dateOfBirth"
                label={t("user.birthday")}
                type="date"
                rref={register}
                required
              />
              <GOInput
                name="phoneNumber"
                label={t("sign.phone")}
                type="number"
                rref={register}
                onChange={handleChange}
                value={addData.phoneNumber}
                required
              />
            </div>
            <div className="flex_box">
              <SmallTitle body={t("user.etcInfo")} />
              <GOInput
                label={t("user.address")}
                name="address"
                value={
                  addData.address
                    ? addData.address.roadAddress
                    : addData.address
                }
                button={t("common.search")}
                onClickButton={() => {
                  viewPost(true);
                }}
                disabled
              />
              <GOInput
                label={t("user.password")}
                name="password"
                rref={register}
                disabled
              />
              <GOInput
                label={t("components.employee.employeeType")}
                name="type"
                value={
                  props.data.type === 0
                    ? t("components.employee.employeeTypeAdmin")
                    : t("components.employee.employeeTypeManager") &&
                      props.data.type === 2
                    ? t("components.employee.employeeTypeTeacher")
                    : t("components.employee.employeeTypeManager")
                }
                disabled
              />
              {lessonInterval > 0 && (
                <GODropbox
                  label={t("components.employee.lessonTime")}
                  name="lessonInterval"
                  rref={register}
                  required
                  data={[
                    {
                      value: 10,
                      body: t("components.employee.lessonTime10min")
                    },
                    {
                      value: 15,
                      body: t("components.employee.lessonTime15min")
                    },
                    {
                      value: 20,
                      body: t("components.employee.lessonTime20min")
                    },
                    {
                      value: 25,
                      body: t("components.employee.lessonTime25min")
                    },
                    {
                      value: 30,
                      body: t("components.employee.lessonTime30min")
                    },
                    {
                      value: 40,
                      body: t("components.employee.lessonTime40min")
                    },
                    {
                      value: 50,
                      body: t("components.employee.lessonTime50min")
                    },
                    {
                      value: 60,
                      body: t("components.employee.lessonTime60min")
                    }
                  ]}
                />
              )}
              {post && (
                <GOPostCode
                  onClickExit={() => {
                    viewPost(false);
                  }}
                  handleChange={handleAddressChange}
                />
              )}
            </div>
          </UFloatingBoxBody>
          <UFloatingBoxFooter>
            <GOButton
              body={t("components.employee.buttonDelete")}
              buttontype="red"
              onClick={() => {
                onDeleteEmployee(t);
              }}
            />
            <GOButton
              buttontype="green"
              body={props.data ? t("employee.edit") : t("employee.add")}
              type="submit"
            />
            <GOButton
              body={t("components.employee.buttonResetPassword")}
              onClick={() => {
                onResetPassword(t);
              }}
            />
            <GOButton body={t("common.no")} onClick={props.onClickExit} />
          </UFloatingBoxFooter>
        </UFloatingContainer>
      ) : (
        <UFloatingContainer as="form" onSubmit={handleSubmit(onSubmit)}>
          <UFloatingBoxHeader>
            <h1>{props.data ? t("employee.edit") : t("employee.add")}</h1>
            <p>{props.data ? t("employee.editInfo") : t("employee.addInfo")}</p>
          </UFloatingBoxHeader>
          <UFloatingBoxBody flex>
            <div className="flex_box">
              <SmallTitle body={t("user.baseInfo")} />
              <GOInput
                label={t("employee.name")}
                name="name"
                rref={register({ maxLength: 30 })}
                error={errors.name}
                required
              />
              {errors.name && (
                <GOError body={`${t("sign.nameErrorMaxLength")}`} />
              )}
              <GODropbox
                label={t("user.sex")}
                name="sex"
                rref={register}
                required
                data={[
                  { value: 0, body: t("common.male") },
                  { value: 1, body: t("common.female") }
                ]}
              />
              <GOInput
                name="dateOfBirth"
                label={t("user.birthday")}
                type="date"
                rref={register}
                required
              />
              <GOInput
                name="phoneNumber"
                label={t("sign.phone")}
                type="number"
                rref={register}
                onChange={handleChange}
                value={addData.phoneNumber}
                required
              />
            </div>
            <div className="flex_box">
              <SmallTitle body={t("user.etcInfo")} />
              <GOInput
                label={t("user.address")}
                name="address"
                value={
                  addData.address
                    ? addData.address.roadAddress
                    : addData.address
                }
                button={t("common.search")}
                onClickButton={() => {
                  viewPost(true);
                }}
                disabled
              />
              <GOInput
                label={t("user.password")}
                name="password"
                rref={register}
                onChange={handleChange}
                value={addData.password}
              />
              <GODropbox
                label={t("components.employee.employeeType")}
                name="type"
                rref={register}
                required
                data={[
                  {
                    value: 0,
                    body: t("components.employee.employeeTypeAdmin")
                  },
                  {
                    value: 1,
                    body: t("components.employee.employeeTypeManager")
                  },
                  {
                    value: 2,
                    body: t("components.employee.employeeTypeTeacher")
                  }
                ]}
              />
              {post && (
                <GOPostCode
                  onClickExit={() => {
                    viewPost(false);
                  }}
                  handleChange={handleAddressChange}
                />
              )}
            </div>
          </UFloatingBoxBody>
          <UFloatingBoxFooter>
            <GOButton
              buttontype="green"
              body={props.data ? t("employee.edit") : t("employee.add")}
              type="submit"
            />
            <GOButton body={t("common.no")} onClick={props.onClickExit} />
          </UFloatingBoxFooter>
        </UFloatingContainer>
      )}
    </GOFloatingbox>
  );
};

export default Add;
